/** The prototype's `.lc-track`/`.lc-fill` (User Limits `barHtml`): an 8px
 * track, the fill in `--inv-auth` (the ramp's second step) or `--danger`
 * once usage is over the limit. A limit of 0 is legitimate (OQ2's restore
 * value), so any usage against it fills the bar red rather than dividing by
 * zero; no limit draws an empty track. */
export function UsageBar({ used, total }: Readonly<{ used: number; total: number | null }>) {
  let pct = 0
  if (total) pct = Math.min(100, (used / total) * 100)
  else if (total === 0 && used > 0) pct = 100
  const over = total != null && used > total
  return (
    <div className="mt-[5px] h-2 rounded bg-[rgba(128,128,128,.16)] overflow-hidden">
      <div
        data-testid="usage-fill"
        className={`h-full rounded ${over ? 'bg-[var(--danger)]' : 'bg-[var(--inv-auth)]'}`}
        style={{ width: `${pct.toFixed(0)}%` }}
      />
    </div>
  )
}
